import { useGetCreditApplicationById } from '@applyonline/shared'
import { EFinancingProgram } from '@if/core/types'
import { useEffect } from 'react'
import { useAppStore } from '../../../data/AppContext'
import { getIdsFromUrl, isMedicardWebSite } from '../../../services/query-string'

export const useCurrentMerchantId = () => {
  const idsFromUrl = getIdsFromUrl()
  const appStore = useAppStore()
  const [creditApp] = useGetCreditApplicationById(idsFromUrl.creditAppId, EFinancingProgram.Personal, false)
  const merchantId = creditApp ? creditApp.merchantId : appStore.merchantId

  const parts = merchantId.split('*')
  return parts.length === 2 ? parts[1] : parts[0]
}

const changeTitle = () => {
  document.title = String(import.meta.env.VITE_MEDICARD_MERCHANT_SITE_TITLE)
}

const changeFavicon = () => {
  window?.document
    ?.querySelector(`link[rel~='icon']`)
    ?.setAttribute('href', String(import.meta.env.VITE_MEDICARD_MERCHANT_SITE_FAVICON))
}

export const useInitializePageTitleAndIcon = () => {
  useEffect(() => {
    const isMedicardHost = isMedicardWebSite()
    if (isMedicardHost) {
      changeTitle()
      changeFavicon()
    }
  }, [])
}
